import React, { useEffect, useState } from 'react';

interface LoadingScreenProps {
  onLoadingComplete: () => void;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ onLoadingComplete }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [shouldHide, setShouldHide] = useState(false);

  useEffect(() => {
    // Animation sequence: square draws (2s) + logo fades in (1s) + brief pause = 3.5s
    const timer = setTimeout(() => {
      setIsLoaded(true);
      // Start fade out after animation sequence completes
      setTimeout(() => {
        setShouldHide(true);
        setTimeout(() => {
          onLoadingComplete();
        }, 600); // Wait for fade out transition
      }, 200);
    }, 3500);

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black overflow-hidden transition-opacity duration-600 ${
        shouldHide ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Container for square and logo */}
      <div className="logo-container relative">
        {/* SVG Square with line drawing animation */}
        <svg 
          className="logo-svg w-[280px] h-[280px] sm:w-[320px] sm:h-[320px]" 
          viewBox="0 0 300 300" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Square Outline */}
          <rect 
            x="10" 
            y="10" 
            width="280" 
            height="280" 
            stroke="white" 
            fill="none" 
            strokeWidth="2"
          />
        </svg>
        
        {/* Logo Image that fades in after square is drawn */}
        <picture>
          <source srcSet="/lovable-uploads/logo-animation.webp" type="image/webp" />
          <img 
            src="/lovable-uploads/logo-animation.webp" 
            alt="Magic Door Logo" 
            className="logo-image absolute inset-0 w-full h-full object-contain p-8 opacity-0"
            width="512"
            height="512"
          />
        </picture>
      </div>
    </div>
  );
};

export default LoadingScreen;